module.exports = __webpack_public_path__ + "static/media/fhh.0c1924ea.png";